export const ACTUALIZAR_LIST_NIVEL4 = "ACTUALIZAR_LIST_NIVEL4";
export const MODIFICAR_NIVEL4 = "MODIFICAR_NIVEL4";
export const AGREGAR_NIVEL4 = "AGREGAR_NIVEL4";  
export const ELIMINAR_NIVEL4 = "ELIMINAR_NIVEL4";